import { render } from "./JsonView.vue?vue&type=template&id=3e0cc423"
import script from "./JsonView.vue?vue&type=script&lang=js"
export * from "./JsonView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__